import {EntityKey} from './entity';

export class EntityLineHeader {

  key!: EntityKey;
  lineId!: string;
  product!: string;
  description!: string;
  itemNumber!: string;
  quantity!: number;
  bestLeadTime!: string;
  unitList!: number;
  multiplier!: number;
  finalUnitPrice!: number;
  finalExtendedPrice!: number;
  customerItemNumber!: string;
  tags!: string;
  prn!: string;
  configured!: boolean;
  configurationComplete!: boolean;
  serialNumber!: string;
  serialNumberRequired!: boolean;
  copyAllowed!: boolean;

}
